import { useCallback } from 'react';
import { useLogAnalyticsEvent } from 'shared/src/hooks/useLogAnalyticsEvent';
import { bridge, isNotNil } from 'shared/src/utils';
import { AdAction } from 'shared/src/utils/eventLogger/adLogger/types';
import type { LikedGoodsCardItem } from '../utils/convertLikedGoodsItemToGoodsData';

export const useLogClickGoods = () => {
  const logAnalyticsEvent = useLogAnalyticsEvent();

  return useCallback(
    (entry: LikedGoodsCardItem) => {
      logAnalyticsEvent({
        name: 'CLICK_GOODS',
        analytics: {
          ...entry.logging.analytics,
        },
        ably_only_log: entry.logging.ably_only_log,
      });

      if (isNotNil(entry.item.ad)) {
        bridge.logAdEvent({ action: AdAction.CLICK, ad: entry.item.ad });
      }
    },
    [logAnalyticsEvent],
  );
};
